import { useQuery } from '@tanstack/react-query';

import { formatData } from 'components/helpers/reactQuery';

export function useAttachmentRotationProcessQuery({ rotationProcessId }) {
  return useQuery({
    enabled: !!rotationProcessId,
    queryKey: ['attachments', 'rotationProcesses', rotationProcessId],
    queryFn: async () => {
      const response = await axios.get(
        `/attachments/rotation_processes/${rotationProcessId}`,
      );

      return response.data;
    },
    refetchInterval: (data) =>
      !data || ['completed', 'failed'].includes(data.data.attributes.status) ?
        false
      : 1000,
    refetchIntervalInBackground: true,
    select: (data) =>
      formatData({
        data,
        resourceTypes: ['attachment', 'coverImage'],
      }),
  });
}
